import React from 'react'
import { Icon as ChakraIcon } from '@chakra-ui/react'
import {
  HubResponsiveValue,
  StandardIconSizes,
  HubStyleObject,
  forwardRef,
} from '@hub/design-system-base'
import { default as WestfieldPlusLogoSVG } from './assets/westfield-plus.inline.svg'

interface WestfieldPlusLogoProps {
  boxSize?: HubResponsiveValue<StandardIconSizes>
  sx?: HubStyleObject
  label?: string
}

export const WestfieldPlusLogo: React.FC<WestfieldPlusLogoProps> = forwardRef<
  WestfieldPlusLogoProps,
  typeof ChakraIcon
>(
  (
    { boxSize = 'size-icon-line-height-shorter', sx, label = 'Westfield Plus' },
    ref
  ) => (
    <ChakraIcon
      aria-label={label}
      ref={ref}
      minW={boxSize}
      maxH={boxSize}
      w="size-auto"
      h="size-auto"
      as={WestfieldPlusLogoSVG}
      sx={sx}
    />
  )
)
